module.exports = __webpack_public_path__ + "static/affiliate/affiliate-square_ski-bro--chf-5e71060d442f2e93d16f6c9d933f2e54.jpg";